import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";
import appstore from "../store/appstore";
const convertTime = (time) => {
  const date = new Date(time);
  
  // Array of month abbreviations
  const monthAbbr = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  
  // Get formatted date
  const formattedDate = `${date.getDate().toString().padStart(2, "0")} ${monthAbbr[date.getMonth()]}, ${date.getFullYear()}`;

  return formattedDate;
};
const News = ({
  img,
  heading,
  detail,
  time,
  isMobileview,
  htmlContent,
  edition,
  setShareModalOpen,
  setSharingLink,
  id
}) => {
  const navigate = useNavigate();
  const { setReadmoreContent } = appstore();
  return (
    <Box
      sx={{
        // width: "100%",
        margin: "auto",
        height: "20%",
        display: "flex",
        // border: "1px solid red",
        padding: "5px",
        background: "white",
        marginTop: isMobileview ? "14px" : "35px",
      }}
      boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
    >
      <img
        src={img}
        style={{
          width: isMobileview ? "35%" : "15%",
          marginTop: "5px",
          marginBottom:isMobileview?'0px': "5px",
          height: "129px",
          borderRadius: "10px",
          marginRight: "15px",
          marginLeft: "10px",
          objectFit: "cover",
        }}
      />{" "}
      <Box
        style={{
          // border: "1px solid red",
          width: isMobileview ? "54%" : "80%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "5px",
        }}
      >
        <Box
          height={"20%"}
          fontSize={"18px"}
          fontWeight={500}
          // marginBottom={'1px'}
          minHeight={isMobileview ? "48px" : "0px"}
          style={{
            position: "relative", // Ensure it doesn't merge with upper elements
            fontWeight: 500,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: isMobileview ? 2 : 1, // Limit to 2 lines
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {heading}
        </Box>
        <Box
          style={{
            position: "relative", // Ensure it doesn't merge with upper elements
            // height: "30%",
            // marginTop: "0px",
            fontSize: "14px",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3, // Limit to 2 lines
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "#8C837D",
          }}
        >
          {detail}
        </Box>
        <Box>
          {" "}
          <Box
            fontSize={"12px"}
            color={"#005AAF"}
            style={{ cursor: "pointer" }}
            onClick={() => {
              console.log("htmlContent", htmlContent);
              setReadmoreContent(htmlContent);
              navigate("/readmore");
            }}
          >
            Read More
          </Box>{" "}
          <Box fontSize={"10px"} color={"#BBBBBB"}>
            <i> {convertTime(time)}</i>, Edition #{edition}
          </Box>
        </Box>
      </Box>
      <MoreVertIcon
        style={{ color: "#C789E4", cursor: "pointer" }}
        onClick={() => {
          setSharingLink(`https://simulyst.com/newsletters?id=${id}`);
          setShareModalOpen(true);
        }}
      />
    </Box>
  );
};

export default News;
